import { Attachment } from '@shared/models';
import { JobBoard } from '@shared/models/job-board';
import { JobBoardPost } from '@shared/models/job-board-post';
import { Pagination } from '@shared/pagination';

export interface JobBoardState {
  list: Pagination<JobBoard>;
  allJobBoardsList: JobBoard[];
  activeJobBoardsForJob: JobBoardPost[];
  isLoading: boolean;
  selectedJobBoard: JobBoard;
  logoAttachmentLoading: boolean;
  headerAttachmentLoading: boolean;
  logoAttachment: Attachment;
  headerAttachment: Attachment;
  totalElementsForExtendedReferral: number;
}

export const initialState: JobBoardState = {
  list: null,
  allJobBoardsList: null,
  activeJobBoardsForJob: null,
  isLoading: false,
  selectedJobBoard: null,
  logoAttachmentLoading: false,
  headerAttachmentLoading: false,
  logoAttachment: null,
  headerAttachment: null,
  totalElementsForExtendedReferral: null,
};
